// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton, ListItemButtonProps } from '@mui/material';
import { SxProps } from '@mui/system';

// ----------------------------------------------------------------------

interface StyledNavItemProps extends ListItemButtonProps {
    component?: any;
    to?: any;
    sx?: SxProps;
}

export const StyledNavItem = styled((props: StyledNavItemProps) => (
    <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
    ...theme.typography.body2,
    height: 48,
    position: 'relative',
    textTransform: 'capitalize',
    color: theme.palette.text.secondary,
    borderRadius: theme.shape.borderRadius,
}));

export const StyledNavItemIcon = styled(ListItemIcon)(({ theme }) => ({
    width: 22,
    height: 22,
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));